const AllPlans = [
  {
    title: "Small Party",
    price: "150",
    subtitle:
      "Et nominavi necessitatibus per. In eos libris inimicus, pri novum viris quaerendum at.",
    text: [
      "0-50 Guests",
      "Non-alcoholic beverages",
      "Snacks",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
    ],
  },
  {
    title: "Medium Party",
    price: "350",
    subtitle:
      "Cu sit case consequat complectitur. An putant dolorem ceteros quo. Modo omnesque constituto cu cum.",
    text: [
      "0-50 Guests",
      "Non-alcoholic beverages",
      "Snacks",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
    ],
  },
  {
    title: "Large Party",
    price: "750",
    subtitle:
      "Civibus sententiae ea sea, te ius tritani fuisset. Ei quas putant vel. Ad odio scripta pri.",
    text: [
      "0-50 Guests",
      "Non-alcoholic beverages",
      "Snacks",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
      "Lorem ipsum dolor",
    ],
  },
];

export default AllPlans;